// extracted by mini-css-extract-plugin
export default {"fullWidthSubscribeWidget":"styles_fullWidthSubscribeWidget__zi5o+"};